export * from './icon-cpu-unlock.component';
